import endpoints from './endpoints';
import request from './request';

const supplierRuleApi = {
    list(companyId) {
        return request.get(
            endpoints.supplier.rules.list(companyId),
        );
    },

    create(companyId, data) {
        return request.post(
            endpoints.supplier.rules.create(companyId),
            data,
        );
    },

    update(companyId, ruleId, data) {
        return request.put(
            endpoints.supplier.rules.update(
                companyId,
                ruleId,
            ),
            data,
        );
    },

    remove(companyId, ruleId) {
        return request.delete(
            endpoints.supplier.rules.remove(
                companyId,
                ruleId,
            ),
        );
    },

    removeAll(companyId) {
        return request.delete(
            endpoints.supplier.rules.removeAll(companyId),
        );
    },
};

export default supplierRuleApi;


// WEBPACK FOOTER //
// ./src/api/supplierRuleApi.js